module.exports = __webpack_public_path__ + "static/media/report-a-problem.a0ce9d10.png";